import { InputAdornment, TextField } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import * as React from 'react'

import Team0Icon from '../../assets/Symbol-1.png'
import Team1Icon from '../../assets/Symbol-2.png'
import Team2Icon from '../../assets/Symbol-3.png'
import Team3Icon from '../../assets/Symbol-4.png'
import Team4Icon from '../../assets/Symbol-5.png'
import { answerInputStyles } from '../../styles/InputStyles'
import { StartedTaskDto } from '../../utils/types'

const teamIconMap: { [key: number]: any } = {
    0: Team0Icon,
    1: Team1Icon,
    2: Team2Icon,
    3: Team3Icon,
    4: Team4Icon
}

interface Props {
    task: StartedTaskDto
    value: string
    valid?: boolean
    onChange(value: string): void
}

export const TaskInput: React.FC<Props> = ({
    task, value, onChange, valid
}) => {

    const styles = answerInputStyles()

    let helperText = ''
    if (valid === false) {
        helperText = 'Forkert svar'
    } else if (valid === true) {
        helperText = 'Rigtigt svar'
    }

    let border = '#FFFFFF !important'
    if (valid === false) {
        border = '#ff0000 !important'
    } else if (valid === true) {
        border = '#008000 !important'
    }

    const teamStyles = makeStyles(() => ({
        centerAdornment: {
            marginLeft: '40%',
            textAlign: 'center'
        },
        centerText: {
            textAlign: 'center'
        },
        container: {
            display: 'flex',
            flexWrap: 'wrap',
            margin: '10px 4px',
            textAlign: 'center',
            justifyContent: 'center !important',
            alignItems: 'center',
            alignSelf: 'center',
            borderColor: '#33949E !important',
            color: 'white !important',
        },

        cssLabel: {
            color: '#33949E',
            textAlign: 'center'
        },

        cssOutlinedInput: {
            '&$cssFocused $notchedOutline': {
                display: 'flex',
                justifyContent: 'center !important',
                alignItems: 'center',
                alignSelf: 'center',
                borderColor: '#33949E !important',
                color: 'white !important',
                textAlign: 'center'
            },
        },

        cssFocused: {
            color: '#33949E !important',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center !important',
            alignItems: 'center',
            alignSelf: 'center'
        },

        notchedOutline: {
            borderWidth: '1px',
            color: 'white',
            textAlign: 'center',
            borderColor: border,
            '&:hover &$cssFocused $notchedOutline': {
                borderColor: 'white !important',
            },
        },

    }))

    const classes = teamStyles()
    return (
        <div className={styles.outerContainer}>
            <div style={{ width: '80%', margin: 'auto' }}>
                {task.taskExplanation && (
                    <p
                        style={{ color: '#33949E', textAlign: 'center', marginBottom: '-12px' }}>
                        {task.taskExplanation}
                    </p>
                )}
            </div>

            <div className={styles.imageContainer}>
                <img
                    style={{ width: 60, height: 60 }}
                    src={teamIconMap[task.playerIndex]}
                    alt={`Team ${task.playerIndex}`}/>
            </div>
            <div className={styles.answers}>
                <TextField
                    variant="outlined"
                    helperText={helperText}
                    value={value}
                    InputLabelProps={{
                        classes: {
                            root: classes.cssLabel,
                            focused: classes.cssFocused,

                        },
                    }}
                    InputProps={{
                        classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline,
                        },
                        startAdornment: (
                            <InputAdornment
                                position="start"
                                classes={{
                                    root: classes.cssOutlinedInput,
                                    positionStart: classes.centerAdornment
                                }} />
                        )
                    }}
                    onChange={(e) => onChange(e.target.value)}/>
            </div>
        </div>
    )
}

TaskInput.defaultProps = {
    valid: undefined
}
